import React, { useState, useEffect } from "react";
import SearchCateField from "../../components/textfield/searchCateField";
import { Table, TableColumn } from "../../components/table";
import MainButton from "../../components/button/mainButton";
import TextBox from "../../components/textfield/textbox";
import HeaderBar from "../../components/header/headerBar";
import EmptyModel from "../../components/modal/emptyModal";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Input from "../../components/textfield/input";
import "../../assets/styles/admin/usedcourse.scss";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import queryString from "query-string";
import { Badge, Avatar, message } from "antd";
import { numberWithCommas } from "../../helpers/functions";
import LoadingCard from "../../components/LoadingCard";
import NoData from "../../components/NoData";

interface ParamTypes {
  id?: string;
}

const CourseList = () => {
  const history = useHistory();
  const { id } = useParams<ParamTypes>();
  const { user, isFetchedUser } = useSelector((state: any) => state);
  const { search } = useLocation();
  const query = queryString.parse(search);
  const [isOpen, setIsOpen] = useState(false);
  const [procedureTypes, setProcedureTypes] = useState<any>([
    {
      value: "code",
      label: "Search by Code",
    },
    {
      value: "name",
      label: "Search by Name",
    },
  ]);
  const [dataTables, setDataTables] = useState<any>([]);
  const [dataHead, setDataHead] = useState<any>({});
  const [searchType, setSearchType] = useState<string>("code");
  const [searchText, setSearchText] = useState<string>("");
  const [useCourse, setUseCourse] = useState<any>({});
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [state, setState] = useState<any>({
    code: "",
    items: [],
    purchaseType: "normal",
  });
  const columns = [
    {
      title: "",
      width: "38px",
    },
    {
      title: "รหัส<br/>Code",
      align: "center",
      width: "83px",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
      width: "203px",
    },
    {
      title: "จำนวน<br/>Quantity",
      align: "center",
      width: "121px",
    },
    {
      title: "จำนวน/คอร์ส<br/>Number/Course",
      align: "center",
      width: "200px",
    },
    {
      title: "รวม<br/>Total",
      align: "center",
      width: "81px",
    },
    {
      title: "ใช้ไป<br/>Used",
      align: "center",
      width: "81px",
    },
    {
      title: "คงเหลือ<br/>Balance",
      align: "center",
      width: "113px",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
      width: "81px",
    },
    {
      title: "เลขที่บัตรคอร์ส<br/>Course Card ID",
      align: "center",
      width: "203px",
    },
    {
      title: "วันที่เริ่ม<br/>Start Date",
      align: "center",
      width: "132px",
    },
    {
      title: "วันหมดอายุ<br/>Expired Date",
      align: "center",
      width: "167px",
    },
    {
      title: "วันที่ต่ออายุ<br/>Renew Date",
      align: "center",
      width: "160px",
    },
    // {
    //   title: "",
    //   colspan: 4,
    //   align: "center",
    //   width: "440px",
    //   // width: "100%",
    // },
    {
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      key: "",
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      title: "",
      align: "center",
      width: "50px",
      // width: "100%",
    },
  ];
  const promotionColumns = [
    {
      title: "",
      width: "38px",
    },
    {
      title: "รหัส<br/>Code",
      align: "center",
      width: "124px",
    },
    {
      title: "รายการ<br/>List",
      align: "center",
      width: "262px",
    },
    {
      title: "รวม<br/>Total",
      align: "center",
      width: "102px",
    },
    {
      title: "ใช้ไป<br/>Used",
      align: "center",
      width: "102px",
    },
    {
      title: "คงเหลือ<br/>Balance",
      align: "center",
      width: "119px",
    },
    {
      title: "วันที่เริ่ม<br/>Start Date",
      align: "center",
      width: "132px",
    },
    {
      title: "วันหมดอายุ<br/>Expired Date",
      align: "center",
      width: "167px",
    },
    {
      title: "วันที่ต่ออายุ<br/>Renew Date",
      align: "center",
      width: "160px",
    },
    // {
    //   title: "",
    //   colspan: 4,
    //   align: "center",
    //   width: "440px",
    //   // width: "100%",
    // },
    {
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      key: "",
      title: "",
      align: "center",
      width: "130px",
      // width: "100%",
    },
    {
      title: "",
      align: "center",
      width: "50px",
      // width: "100%",
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  let coursecardId = ["R9-CN61080007 ", "xxxxxx ", "Acne Clear", " 5 "];
  function RowClick(record: number) {
    console.log("record", record + 1);
  }

  const getData = async (search: string = "", _searchType?: string) => {
    setLoading(true);
    const { data } = await axios.get(
      `/use-courses/course/${id}?${
        _searchType ? _searchType : searchType
      }=${search}`
    );
    if (!data) return;
    // console.log("data =>", data);

    setState(data);
    setDataLoaded(true);
    setLoading(false);
  };

  const onClickPrint = async (item: any) => {
    console.log("on click print...", item._id);
  };

  useEffect(() => {
    getData();

    // console.log("user =>", user);
  }, []);

  return (
    <div>
      <HeaderBar title={`USED COURSE / ${state.code}`} btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}

      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div className="row" style={{ padding: "0px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc "
              title="รหัสลูกค้า/CN"
              value={state.memberCode}
            />
            <TextBox
              className="col-3 text-box-usedc "
              title="ชื่อลูกค้า/Customer Name"
              value={state.memberName}
            />
            <TextBox
              className="col-3 text-box-usedc "
              title="ราคาขาย/Sale Price"
              value={state.formatPurchaseAmount}
              align="right"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="ชำระแล้ว/Paid"
              value={state.formatBalance}
              align="right"
            />
          </div>
        </div>
        <div style={{ marginTop: "40px" }}>
          <h5>
            <b>รายการคอร์ส/Course List</b>
          </h5>
        </div>
        <div className="card-view " style={{ padding: "20px" }}>
          <SearchCateField
            placeholder="Search for  Name, Code"
            color="#fff"
            options={procedureTypes}
            defaultValue={searchType}
            onTypeChange={(value: any) => {
              setSearchType(value);
              console.log("change =>", value);

              getData(searchText, value);
            }}
            onChange={(e: any) => {
              const value = e.target.value;

              getData(value);

              setSearchText(value);

              console.log("change =>", value);
            }}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          {!dataLoaded || loading ? (
            // table loading
            <LoadingCard />
          ) : !state.items.length ? (
            <NoData />
          ) : state?.purchaseType === "normal" ? (
            // table normal
            <>
              <Table header={columns} fixed={true} headerPadding="7px 10px">
                {state.items.map((item: any, index: number) => (
                  <tr
                    key={index}
                    // onClick={() => RowClick(index)}
                    // style={{ cursor: "pointer" }}
                  >
                    <TableColumn align="center">{index + 1}</TableColumn>
                    <TableColumn>{item.code}</TableColumn>
                    <TableColumn>{item.name}</TableColumn>
                    <TableColumn align="right">
                      {item?.root?.quantity}
                    </TableColumn>
                    <TableColumn align="right">{item?.number}</TableColumn>
                    <TableColumn align="right">{item.formatTotal}</TableColumn>
                    <TableColumn align="right">{item.formatUsed}</TableColumn>
                    <TableColumn align="right" key={index}>
                      {item.formatBalance}
                    </TableColumn>
                    <TableColumn align="center">{item.unit}</TableColumn>
                    <TableColumn align="center">{item.courseId}</TableColumn>
                    <TableColumn align="center">
                      {item.formatStartDate}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatExpiredDate}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatRenewDate}
                    </TableColumn>
                    {/* start actions */}
                    <TableColumn align="center" width="130px">
                      <MainButton
                        title="ใช้คอร์ส/Used Course"
                        width="115px"
                        height="42px"
                        disabled={!item?.balance}
                        background={
                          // item.status === "normal" ? "#5BAEA9" : "#AEAEAE"
                          "#5BAEA9"
                        }
                        style={{ padding: "0" }}
                        titleStyle={{ margin: "0" }}
                        onClick={() => {
                          console.log("on click...");
                          setUseCourse(item);

                          console.log("item =>", item);

                          history.push(
                            `/usedcourse/coursedetail/${state._id}/courseList1?itemId=${item._id}`
                          );

                          // setIsOpen(true);

                          // old
                          // item.status === "normal"
                          //   ? setIsOpen(true)
                          //   : setIsOpen(false);
                        }}
                      ></MainButton>
                    </TableColumn>
                    <TableColumn align="center" width="130px" padding="0">
                      <MainButton
                        title="ขอต่ออายุ/ Renewal Request"
                        width="115px"
                        height="42px"
                        disabled={!item?.expiredDate}
                        background={
                          // item.status === "normal" ? "#E76464" : "#AEAEAE"
                          "#E76464"
                        }
                        style={{ padding: "0" }}
                        titleStyle={{ margin: "0" }}
                        onClick={
                          () =>
                            history.push(
                              `/usedcourse/coursedetail/1/courserenew`
                            )
                          // item.status === "normal"
                          //   ? history.push(`/usedcourse/coursedetail/1/courserenew`)
                          //   : ""
                        }
                      ></MainButton>
                    </TableColumn>
                    {user?.permission?.code === "admin" && (
                      <TableColumn align="center" width="130px" padding="0">
                        <MainButton
                          title="สร้าง GE/<br>Create GE"
                          width="115px"
                          height="42px"
                          background={
                            // item.status === "normal" ? "#FFA24B" : "#AEAEAE"
                            "#FFA24B"
                          }
                          style={{ padding: "0" }}
                          titleStyle={{ margin: "0" }}
                          onClick={
                            () =>
                              history.push(
                                `/usedcourse/coursedetail/1/creategift`
                              )
                            // item.status === "normal"
                            //   ? history.push(`/usedcourse/coursedetail/1/creategift`)
                            //   : ""
                          }
                        ></MainButton>
                      </TableColumn>
                    )}
                    <TableColumn align="center" width="50px" padding="0">
                      {item?.balance ? (
                        <a onClick={() => onClickPrint(item)}>
                          <Avatar src="/print.svg" shape="square" />
                        </a>
                      ) : (
                        <Avatar src="/print_disabled.svg" shape="square" />
                      )}
                    </TableColumn>
                    {/* end actions */}
                  </tr>
                ))}
              </Table>
            </>
          ) : state?.purchaseType === "promotion" ? (
            // table promotion
            <>
              <Table
                header={promotionColumns}
                fixed={true}
                headerPadding="7px 10px"
              >
                {state.items.map((item: any, index: number) => (
                  <tr
                    key={index}
                    // onClick={() => RowClick(index)}
                    // style={{ cursor: "pointer" }}
                  >
                    <TableColumn align="center">{index + 1}</TableColumn>
                    <TableColumn>{item.code}</TableColumn>
                    <TableColumn>{item.name}</TableColumn>
                    <TableColumn align="right">{item.formatTotal}</TableColumn>
                    <TableColumn align="right">{item.formatUsed}</TableColumn>
                    <TableColumn align="right" key={index}>
                      {item.formatBalance}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatStartDate}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatExpiredDate}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatRenewDate}
                    </TableColumn>
                    {/* start actions */}
                    <TableColumn align="center" width="130px">
                      <MainButton
                        title="ใช้คอร์ส/Used Course"
                        width="115px"
                        height="42px"
                        disabled={!item?.balance}
                        background={
                          // item.status === "normal" ? "#5BAEA9" : "#AEAEAE"
                          "#5BAEA9"
                        }
                        style={{ padding: "0" }}
                        titleStyle={{ margin: "0" }}
                        onClick={() => {
                          console.log("on click...");
                          setUseCourse(item);

                          console.log("item =>", item);

                          history.push(
                            `/usedcourse/coursedetail/${state._id}/courseListPro1?itemId=${item._id}`
                          );

                          // setIsOpen(true);

                          // old
                          // item.status === "normal"
                          //   ? setIsOpen(true)
                          //   : setIsOpen(false);
                        }}
                      ></MainButton>
                    </TableColumn>
                    <TableColumn align="center" width="130px" padding="0">
                      <MainButton
                        title="ขอต่ออายุ/ Renewal Request"
                        width="115px"
                        height="42px"
                        disabled={!item?.expiredDate}
                        background={
                          // item.status === "normal" ? "#E76464" : "#AEAEAE"
                          "#E76464"
                        }
                        style={{ padding: "0" }}
                        titleStyle={{ margin: "0" }}
                        onClick={
                          () =>
                            history.push(
                              `/usedcourse/coursedetail/1/courserenew`
                            )
                          // item.status === "normal"
                          //   ? history.push(`/usedcourse/coursedetail/1/courserenew`)
                          //   : ""
                        }
                      ></MainButton>
                    </TableColumn>
                    {user?.permission?.code === "admin" && (
                      <TableColumn align="center" width="130px" padding="0">
                        <MainButton
                          title="สร้าง GE/<br>Create GE"
                          width="115px"
                          height="42px"
                          background={
                            // item.status === "normal" ? "#FFA24B" : "#AEAEAE"
                            "#FFA24B"
                          }
                          style={{ padding: "0" }}
                          titleStyle={{ margin: "0" }}
                          onClick={
                            () =>
                              history.push(
                                `/usedcourse/coursedetail/1/creategift`
                              )
                            // item.status === "normal"
                            //   ? history.push(`/usedcourse/coursedetail/1/creategift`)
                            //   : ""
                          }
                        ></MainButton>
                      </TableColumn>
                    )}
                    <TableColumn align="center" width="50px" padding="0">
                      {item?.balance ? (
                        <a onClick={() => onClickPrint(item)}>
                          <Avatar src="/print.svg" shape="square" />
                        </a>
                      ) : (
                        <Avatar src="/print_disabled.svg" shape="square" />
                      )}
                    </TableColumn>
                    {/* end actions */}
                  </tr>
                ))}
              </Table>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
export default CourseList;
